export default "__VITE_ASSET__DVm8pIGT__"